import { BuiltInPlan } from "../../lib/workout";

export default {
  id: "94dc1b15-1f96-4ede-a74e-e63629429568",
  title: "New (miles)",
  raceType: "Template",
  units: "miles",
  workouts: [
    {
      description: "Easy 5 miles",
      totalDistance: 5,
    },
  ],
} as BuiltInPlan;